import { render, staticRenderFns } from "./PageFooters.vue?vue&type=template&id=e50d35fa&scoped=true&"
import script from "./PageFooters.vue?vue&type=script&lang=ts&"
export * from "./PageFooters.vue?vue&type=script&lang=ts&"
import style0 from "./PageFooters.vue?vue&type=style&index=0&id=e50d35fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50d35fa",
  null
  
)

export default component.exports